/**
 * Utilidades para cuando Galia corre EMBEBIDA en un iframe (p. ej. dentro del
 * player de Apolearn). En ese caso la Permissions Policy del iframe puede no
 * incluir `allow="microphone"`, y el navegador bloquea getUserMedia
 * (NotAllowedError / "microphone is not allowed in this document").
 *
 * La solución robusta —independiente de cómo Apolearn embeba el módulo— es
 * reabrir Galia en una pestaña nueva (documento de nivel superior), donde el
 * micrófono sí está permitido.
 */

import sessionService from '../services/sessionService';

/** True si la app corre dentro de un iframe. */
export function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Acceder a window.top entre orígenes distintos lanza → estamos embebidos.
    return true;
  }
}

/**
 * Reabre la app en una pestaña nueva conservando la sesión. La identidad ya no
 * viaja en parámetros planos del URL (fases 2-3 del plan de seguridad LTI) y el
 * localStorage del iframe de Apolearn está PARTICIONADO (la pestaña top-level no
 * lo ve), así que se adjunta el token de sesión firmado como `?session=`; la
 * pestaña nueva lo canjea en /api/session/redeem y lo borra de la barra de
 * direcciones. Debe llamarse desde un gesto del usuario (click) para evitar el
 * bloqueo de popups.
 */
export function openStandalone(): Window | null {
  try {
    const url = new URL(window.location.href);
    const token = sessionService.getSessionToken();
    if (token) {
      url.searchParams.set('session', token);
    }
    return window.open(url.toString(), '_blank', 'noopener');
  } catch {
    return null;
  }
}
